import styled, { keyframes } from "styled-components";
import { BtnProps, SwitcherProps } from "./types";

export const Container = styled.div`
  width: 100%;
  height: auto;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
`;

export const WrapperTextSteps = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  color: #3a2e83;
  font-family: "Mangueira", "Poppins", "Open-sans", sans-serif, -apple-system,
    BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue";

  margin-left: auto;
  margin-right: auto;
  h4 {
    margin: 0;
    font-weight: 600;
    font-size: 1rem;
    letter-spacing: 0.51px;
  }
  span {
    font-size: 15px;
    text-align: center;
  }
`;

export const WrapperSteps = styled.div`
  width: 100%;
  height: auto;
  background-color: var(--white);
  border-radius: 0px 0px 32px 32px;
  box-shadow: 0px 0px 12px #0000001f;
  border-bottom: 1px solid #0000001f;
  padding: 20px 10px 0px 10px;
`;

export const SectionPayment = styled.section`
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px 10px;

  @media (max-width: 500px) {
    padding: 20px 0px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0px 10px;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const WrapperSelectRoom = styled.div`
  width: 60%;
  min-width: 300px;
  height: auto;
  overflow-y: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 500px) {
    min-width: 400px;
  }
  @media (max-width: 400px) {
    min-width: 380px;
  }
`;

export const BoxRoom = styled.div`
  width: 100%;
  max-width: 514px;
  height: auto;
  margin: 10px 0px;
  border: 1px solid var(--gray500Opacity);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  scroll-margin-top: 80px; // header height
  @media (max-width: 500px) {
    border: 0;
    border-top: 1px solid var(--gray500Opacity);
    border-radius: 0px;
  }
`;

export const TitleRoom = styled.h4`
  margin: 0;
  font-family: "Mangueira", "Poppins", "Open-sans", sans-serif, -apple-system,
    BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue";
  font-size: 1.3rem;
  color: var(--purple600);
  text-transform: uppercase;
  font-weight: bold;
`;

export const WrapperContent = styled.div`
  width: 100%;
  padding: 20px 0px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  position: relative;
`;

export const Subtitle = styled.h6`
  margin: 0;
  font-family: "Mangueira", "Poppins", "Open-sans", sans-serif, -apple-system,
    BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue";
  font-size: 20px;
  color: var(--orange600);
  font-weight: bold;
  margin-bottom: 10px;

  @media (max-width: 500px) {
    text-align: center;
  }
`;

export const WrapperRadios = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  scroll-margin-top: 80px; // header height
`;

export const PolyticsArea = styled.div`
  width: 100%;
  max-width: 514px;
  height: auto;
  border-radius: 20px;
  border: 1px solid var(--gray500Opacity);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 8px;
  @media (max-width: 500px) {
    border: 0;
  }
`;

export const WrappertextAndSwitcher = styled.div`
  width: 100%;
  display: flex;
  @media (max-width: 500px) {
    padding-left: 8px;
  }

  p {
    margin: 0;
    width: 100%;
    max-width: 400px;
    text-align: left;
    color: var(--purple600);
    font-family: "Mangueira", "Poppins", "Open-sans", sans-serif, -apple-system,
      BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
      "Fira Sans", "Droid Sans", "Helvetica Neue";
    font-size: 14px;
    padding-left: 8px;
  }
  strong {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const Switcher = styled.div<SwitcherProps>`
  width: 28px;
  height: 16px;
  background-color: ${({ active }) =>
    active ? "var(--pink400)" : "var(--gray500)"};
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
`;

export const ItemCircle = styled.div<SwitcherProps>`
  width: 16px;
  height: 16px;
  background-color: ${({ active }) =>
    active ? "var(--pink600)" : "var(--white)"};
  border-radius: 50%;
  position: absolute;
  box-shadow: 0px 0px 24px var(--gray300);
  cursor: pointer;
  right: ${({ active }) => (active ? 0 : 15)}px;
  transition: all 0.3s ease-in-out;
`;

export const WrapperBtnReserve = styled.div`
  width: 100%;
  max-width: 514px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const BtnKeep = styled.button<BtnProps>`
  width: 100%;
  max-width: 348px;
  height: 40px;
  background-color: var(--pink600);
  border-radius: 25px;
  font-size: 1rem;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 12px 0px;
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  border: 0;
  &:hover {
    background-color: ${({ disabled }) =>
      disabled ? "trasparent" : "var(--pink400)"};
  }
`;

export const TextIndicate = styled.div`
  color: var(--orange600);
  padding-left: 34;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
`;

export const PenaltyAmount = styled.div`
  color: var(--red600);
  font-weight: bold;
  font-size: 14px;
  width: 100%;
  max-width: 500px;
  text-align: justify;
  margin-top: 8px;
  margin-bottom: 4px;
  @media (max-width: 500px) {
    text-align: center;
  }
`;

export const Rotate = keyframes`
from{
    transform:rotate(0deg);
}
to{
    transform:rotate(360deg);
}
`;

export const LoadingBtn = styled.div`
  width: 30px;
  height: 30px;
  background-color: var(--pink600);
  border-radius: 50%;
  border: 4px solid var(--white);
  border-top-color: var(--pink600);
  animation: ${Rotate} 1s linear infinite;
`;
